import axios from "axios";

export const GenerateIntentId = async () => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
        body: JSON.stringify({
            client_id: "64b66c2eef4079001a89ca07",
            secret: "28ec3808c96b7eea28d1a1f6d86bb7",
            mode: "PAYMENT",
            amount: "12.34",
            description: "Desc",
            ach_class: "ppd",
            origination_account_id: "9853defc-e703-463d-86b1-dc0607a45359",
            user: {
                legal_name: "Test"
            }
        })
    };
    fetch('https://sandbox.plaid.com/transfer/intent/create', requestOptions)
        .then((response) => console.log('res--------', response))
        .catch((err) => console.log('err-------', err))
};

export const GenerateLinkToken = async () => {
    const body = {
        client_id: "64b66c2eef4079001a89ca07",
        secret: "28ec3808c96b7eea28d1a1f6d86bb7",
        user: {
            client_user_id: "unique-per-user"
        },
        client_name: "Plaid App",
        products: ["transfer"],
        country_codes: ["US"],
        language: "en",
        transfer: {
            intent_id: "e0b89d89-20f5-0ddc-c7ce-b64f09d17e82"
        },
        link_customization_name: "transfer"
    }

    const response = await axios.post('https://sandbox.plaid.com/link/token/create', body, {
        headers: {
            "Content-Type": "application/json",
        }
    });

    return response
}

export const CreatePaymentIntent = async (token) => {
    var params = new URLSearchParams();
    params.append('amount', 1000);
    params.append('currency', 'usd');
    params.append('payment_method_types[]', token.type);

    const response = await axios.post('https://api.stripe.com/v1/payment_intents', params, {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: "Bearer " + process.env.REACT_APP_SECRET_KEY,
        }
    });

    return response
}